import React from 'react';

import { useAppContext } from 'hooks/useContext';
import { ResizableRowsContainer, RowContainer } from './styles';

// Split children into multiple rows that can be resized
export default function ResizableRows({ children, sizes }) {
  const { isDarkMode } = useAppContext();
  const splitSizes = sizes || Array(children.length).fill(100 / children.length);

  return (
    <ResizableRowsContainer
      onDrag={() => window.dispatchEvent(new Event('resize'))}
      sizes={splitSizes}
      minSize={20}
      expandToMin={false}
      gutterSize={5}
      gutterAlign="center"
      snapOffset={30}
      dragInterval={1}
      direction="vertical"
      cursor="row-resize"
      splitdarkmode={isDarkMode ? 'true' : undefined}
    >
      {children && children.map((child, index) => <RowContainer key={index}>{child}</RowContainer>)}
    </ResizableRowsContainer>
  );
}
